"use strict";
/*!
 * Copyright (C) 2019, NewFoundry, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;
exports.ChangeLog = void 0;

var lodash_1 = __importDefault(require("lodash"));

var Terms_1 = require("./Terms");

var _1 = require(".");

var ChangeLog = function () {
  function ChangeLog(response) {
    this.logs = [];
    this.response = response;
  }

  ChangeLog.prototype.add = function (token, opts) {
    if (lodash_1["default"].isString(token)) {
      this._push(__assign({
        id: token
      }, opts));

      return;
    }

    switch (token.token) {
      case Terms_1.Id.token:
        this._push(Terms_1.Id.log(__assign({
          id: token.value
        }, opts)));

        break;

      default:
        this._push(__assign({
          action: token.token
        }, opts));

    }
  };

  ChangeLog.prototype.fetch = function () {
    return this.logs;
  };

  ChangeLog.prototype.finish = function (diff, selection, configuration) {
    var _this = this;

    var attributes = lodash_1["default"].flatten(lodash_1["default"].keys(diff)).filter(function (a) {
      return !lodash_1["default"].includes(lodash_1["default"].keys(selection), a.substring(1));
    });
    var properties = lodash_1["default"].flatten(lodash_1["default"].values(diff)).filter(function (p) {
      return !lodash_1["default"].includes(lodash_1["default"].values(selection), p.substring(1));
    });
    var modelNames = this.response.engine.getModelNames();
    var removedAttributes = [];
    attributes.forEach(function (attr) {
      var id = attr.substring(1);

      if (attr[0] === '-') {
        _this._push({
          action: 'remove',
          id: id,
          collection: modelNames.collections.attribute
        });

        removedAttributes.push(id);
      }
    });
    properties.forEach(function (prop) {
      var id = prop.substring(1);

      if (prop[0] === '+') {
        _this._push({
          action: 'add',
          id: id,
          collection: modelNames.collections.property
        });
      }

      if (prop[0] === '-') {
        var property = _this.response.engine.data.properties.byId[id];

        var defaultAttribute = _this.response.engine.getParentAttribute(property);

        if (lodash_1["default"].includes(removedAttributes, defaultAttribute)) {
          return;
        }

        if (lodash_1["default"].includes(lodash_1["default"].keys(selection), defaultAttribute)) {
          return;
        }

        _this._push({
          action: 'remove',
          id: id,
          collection: modelNames.collections.property
        });
      }
    });

    this._runOrs(configuration);

    var forces = this.logs.filter(function (log) {
      return log.force;
    });
    var changes = this.logs.filter(function (log) {
      var skip = false;

      if (log.collection === modelNames.collections.property) {
        var engine = _this.response.engine;
        var property = engine.data.properties.byId[log.id];
        var attribute_1 = engine.getParentAttribute(property);
        forces.some(function (f) {
          if (f.collection === modelNames.collections.attribute) {
            if (f.id === attribute_1) {
              skip = true;
              return true;
            }
          }

          return false;
        });
      }

      return !log.force && !skip;
    });
    return {
      changes: changes,
      forces: forces
    };
  };

  ChangeLog.prototype._runOrs = function (configuration) {
    var _this = this;

    var modelNames = this.response.engine.getModelNames();
    this.logs = this.logs.filter(function (log) {
      if (log.action === 'OR') {
        var ors = log.or;

        if (lodash_1["default"].intersection(lodash_1["default"].values(configuration), ors.map(function (o) {
          return o.id;
        })).length) {
          return false;
        }
      }

      return true;
    });
    this.logs.filter(function (log) {
      return log.action === 'OR';
    }).forEach(function (log) {
      var ors = log.or;
      ors.forEach(function (or) {
        var engine = new _1.RulesEngine();
        var data = lodash_1["default"].cloneDeep(_this.response.engine.data);
        data.rules = data.rules.filter(function (r) {
          return r.id !== log.ruleId;
        }).map(function (r) {
          return r.orig;
        });
        engine.init(data);

        if (or.collection === modelNames.collections.property) {
          var id = or.id;
          var option = engine.data.properties.byId[id];
          var attribute = engine.getParentAttribute(option);
          var selection = {};
          selection[attribute] = engine.getId(option);
          or.response = engine.run(lodash_1["default"].clone(_this.response.after), selection);
        }
      });
    });
  };

  ChangeLog.prototype._push = function (entry) {
    var matches = function matches(e1, e2) {
      return e1.action === e2.action && e1.collection === e2.collection && e1.id === e2.id;
    };

    if (lodash_1["default"].isEmpty(lodash_1["default"].intersectionWith(this.logs, [entry], matches))) {
      this.logs.push(entry);
    }
  };

  return ChangeLog;
}();

exports.ChangeLog = ChangeLog;